/**
 * The list of the name of the cookies this library is using.
 */
export enum CookiesNames {
  rcPlus = "rc_plus",
  rcPPId = "rc_ppid",
  rcVisitor = "rc_visitor",
  rcVisitorBackup = "rc_visitor_bck",
  lotame = "_cc_id",
  blueConic = "BCSessionID",
}
